<div class="card section-card">
  <div class="card-header">{{ 'i18n.domain.theme-showcase.validation.title' | translate }}</div>
  <div class="card-body d-flex flex-wrap gap-2 align-items-center justify-content-between">
    <small class="text-body-secondary">
      {{ 'i18n.domain.theme-showcase.validation.description' | translate }}
    </small>
    <div class="d-flex flex-wrap gap-2 mt-2 justify-content-end">
      <button type="button" class="btn btn-outline-secondary" (click)="validate.emit()">
        {{ 'i18n.domain.theme-showcase.validation.validateButton' | translate }}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="reset.emit()">
        {{ 'i18n.domain.theme-showcase.validation.resetButton' | translate }}
      </button>
    </div>
  </div>
</div>
